<template></template>
<script>
import { wxRequest } from '@/api/user'
import { Dialog } from 'vant';
export default {
    data() {
        return {
            payUrl: '',
            orderNo: ''
        }
    },
    created() {
        var appid = "wxb4bff16244869bed";
        localStorage.setItem('isHeadquarterAppid', true);
        localStorage.setItem('appid', appid);
        var redirectUrl = window.location.href;
        var index = redirectUrl.indexOf('code');
        redirectUrl = encodeURIComponent(redirectUrl);
        if (index < 0) {
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
        } else {
            var search = window.location.search;
            var startIndex = search.indexOf('code');
            var endIndex = search.indexOf('&', startIndex);
            var str = search.slice(startIndex, endIndex);
            var code = str.slice(str.indexOf('=') + 1);
            var orderNo = this.$route.query.orderNo;
            var payType = this.$route.query.payType;
            wxRequest("order/get/ma/pay/info", { orderNo: orderNo, code: code, payType: payType }, "post").then(res => {
                if (res.data.code == 400) {
                    Dialog.alert({ title: '提示', message: res.data.message });
                } else if (payType == 61) { //斗洪支付
                    var param = res.data.data;
                    if (typeof WeixinJSBridge == "undefined") {
                        if (document.addEventListener) {
                            document.addEventListener(
                                "WeixinJSBridgeReady",
                                this.onBridgeReady,
                                false
                            );
                        } else if (document.attachEvent) {
                            document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                            document.attachEvent(
                                "onWeixinJSBridgeReady",
                                this.onBridgeReady
                            );
                        }
                    } else {
                        this.onBridgeReady(param);
                    }
                } else if (payType == 99) { //微信支付
                    var param = res.data.data.param;
                    if (typeof WeixinJSBridge == "undefined") {
                        if (document.addEventListener) {
                            document.addEventListener(
                                "WeixinJSBridgeReady",
                                this.onBridgeReady,
                                false
                            );
                        } else if (document.attachEvent) {
                            document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                            document.attachEvent(
                                "onWeixinJSBridgeReady",
                                this.onBridgeReady
                            );
                        }
                    } else {
                        this.onBridgeReady(param);
                    }
                } else {
                    Dialog.alert({ title: '提示', message: '不支持的支付类型！请联系客服处理！' });
                }
            })
        }
    },
    methods: {
        //流量套餐充值时唤起微信支付
        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    _this.$router.push({
                    path: "/user/paymentAmountApp"
                  });
                }
            });
        },
        //获取url参数
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) { return pair[1]; }
            }
            return false;
        },
    }
}
</script>
